import Carousel from 'Assets/js/lib/carousel'
;(function () {
  const components = {
    featuredItemsCarousel: SAXX.Init.Component((node) => {
      new Carousel(node, { cell: '.featured-items--item' })
    }),
  }
  Object.assign(SAXX.Init.Components, components)
})()
